import { Box } from "@mui/material";
import { partial } from "lodash-es";
import { notEmpty } from "../../../utils/not-empty";
import { Channels } from "../types";
import { ChannelCard } from "./channel-card";

import type { ChannelName } from "../types";
import type { FC } from "react";

export const ChannelSelect: FC<{
  channels: ChannelName[];
  selectedChannel: ChannelName;
  disabled: boolean;
  onSelect: (name: NonNullable<ChannelName>) => void | Promise<void>;
}> = ({ channels, selectedChannel, disabled, onSelect }) => (
  <>
    {channels.filter(notEmpty).map((name, key) => (
      <Box key={key} sx={{ mr: 1 }}>
        <ChannelCard
          buttonText={Channels[name].buttonText}
          onClick={partial((p) => {
            void onSelect(p);
          }, name)}
          name={name}
          disabled={disabled}
          selected={name === selectedChannel}
        />
      </Box>
    ))}
  </>
);
